import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";

import Confetti from "./Confetti";


export default class ConfettiAnim extends PIXI.Container
{
    private _back: PIXI.Container = null;
    private _front: PIXI.Container = null;
    private _arrBackConfetti: Array<Confetti> = null;
    private _arrFrontConfetti: Array<Confetti> = null;
    private _backElapsedTime: number = null;
    private _frontElapsedTime: number = null;


    public constructor() 
    {
        super();
    }

    public init(): void
    {
        this._arrBackConfetti = [];
        this._arrFrontConfetti = [];
        this._backElapsedTime = 10;
        this._frontElapsedTime = 10;

        this._back = new PIXI.Container();
        this._back.y = -ServiceLocator.app.safeAreaMarginY - 90;
        this.addChild( this._back );
        //
        this._front = new PIXI.Container();
        this._front.y = -ServiceLocator.app.safeAreaMarginY - 90;
        this.addChild( this._front );
    }

    public update( dt: number ): void
    {
        this._backElapsedTime += dt;
        if ( this._backElapsedTime > 0.5 * 2 )
        {
            const kConfettiCount: number = Math.floor( Math.random() * 10 * 0.5 ) + 2;
            let isLeftSide: boolean = true; 
            for ( let i: number = 0; i < kConfettiCount; ++i )
            {
                let offsetX: number = -ServiceLocator.app.safeAreaWidth * 0.5 * Math.random();
                let speed: PIXI.Point = new PIXI.Point();
                speed.y = Math.random() * 100 + 200;
                speed.x = Math.random() * 50;
                let angularSpeed: number = Math.random() * 90 + 180;
                if ( !isLeftSide )
                {
                    speed.x = -speed.x;
                    angularSpeed = -angularSpeed;
                    offsetX = -offsetX;
                }
                const kSpriteId: string = "confetti_" + ( Math.floor( Math.random() * 11 ) );
                let confetti: Confetti = new Confetti( kSpriteId, speed, angularSpeed );
                confetti.position.set( ServiceLocator.app.width * 0.5 + offsetX, 0 );
                this._back.addChild( confetti );

                this._arrBackConfetti.push( confetti );

                isLeftSide = !isLeftSide;
            }

            this._backElapsedTime = 0;
        }

        const kRemoveY: number = ServiceLocator.app.safeAreaHeight + 90;
        for ( let i: number = this._arrBackConfetti.length - 1; i >= 0; --i )
        {
            let confetti: Confetti = this._arrBackConfetti[ i ];
            if ( confetti.y > kRemoveY )
            {
                confetti.parent.removeChild( confetti );
                this._arrBackConfetti.splice( i, 1 );
            }
            else
            {
                confetti.update( dt );
            }
        }

        this._frontElapsedTime += dt;
        if ( this._frontElapsedTime > 1 * 2 )
        {
            const kConfettiCount: number = Math.floor( Math.random() * 2 * 0.5 ) + 2;
            let isLeftSide: boolean = true; 
            for ( let i: number = 0; i < kConfettiCount; ++i )
            {
                let offsetX: number = -ServiceLocator.app.safeAreaWidth * 0.5 * Math.random();
                let speed: PIXI.Point = new PIXI.Point();
                speed.y = ( Math.random() * 100 + 200 ) * 2;
                speed.x = Math.random() * 50;
                let angularSpeed: number = ( Math.random() * 90 + 180 ) * 1.5;
                if ( !isLeftSide )
                {
                    speed.x = -speed.x;
                    angularSpeed = -angularSpeed;
                    offsetX = -offsetX;
                }
                const kSpriteId: string = "confetti_" + ( Math.floor( Math.random() * 11 ) );
                let confetti: Confetti = new Confetti( kSpriteId, speed, angularSpeed );
                confetti.scale.set( confetti.scale.x * 2 );
                confetti.position.set( ServiceLocator.app.width * 0.5 + offsetX, 0 );
                this._front.addChild( confetti );

                this._arrFrontConfetti.push( confetti );

                isLeftSide = !isLeftSide;
            }

            this._frontElapsedTime = 0;
        }

        const kFrontRemoveY: number = ServiceLocator.app.safeAreaHeight + 180;
        for ( let i: number = this._arrFrontConfetti.length - 1; i >= 0; --i )
        {
            let confetti: Confetti = this._arrFrontConfetti[ i ];
            if ( confetti.y > kFrontRemoveY )
            {
                confetti.parent.removeChild( confetti );
                this._arrFrontConfetti.splice( i, 1 );
            }
            else
            {
                confetti.update( dt );
            }
        }
    }

    public end(): void
    {
        this._back.parent.removeChild( this._back );
        this._back.destroy( { children: true } );
        this._back = null;

        this._front.parent.removeChild( this._front );
        this._front.destroy( { children: true } );
        this._front = null;
    }
}